import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { SummaryItem } from '../../../models';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-formly-summary',
  templateUrl: './formly-summary.component.html',
  styleUrl: './formly-summary.component.scss',
})
export class FormlySummaryComponent extends FieldType {
  get observableModel(): Observable<any> {
    return of(this.model);
  }

  get anyItems(): boolean {
    return this.field.props.fields.some((x) => this.model[x.key]);
  }

  summaryItems(): SummaryItem[] {
    return this.field.props.fields.map((x) => ({ label: x.label, value: this.model[x.key] }));
  }
}
